export default "__VITE_ASSET__ZCAPZpFs__"